import { RequestStatus } from 'features/request/requestSlice';
import { useRequest } from 'features/request/useRequest';
import type { IWorkOrderData } from 'pages/Project/UerProject/WorkOrder/WorkOrderRequisites';
import { parseWorkOrder } from 'pages/Project/UerProject/WorkOrder/WorkOrderRequisites';
import type { DefaultItemSelect } from 'uikit';
import { Button, cnMixSpace } from 'uikit';

import type React from 'react';
import { useCallback, useMemo, useState } from 'react';

import { gqlWorkOrderVersion } from '../workOrderVersionQueries';

import { WorkOrderVersionRequisitesUpdate } from './WorkOrderVersionRequisitesUpdate';

interface IWorkOrderVersionRequisitesProps {
    workOrderId: number;
    isDisabled: boolean;
    activeItemVersion?: DefaultItemSelect;
    withButton?: boolean;
    isOpenOuter?: boolean;
    refBtn?: React.RefObject<HTMLButtonElement>;
    setIsOpenOuter?: React.Dispatch<React.SetStateAction<boolean>>;
}

export const WorkOrderVersionRequisites: React.FC<IWorkOrderVersionRequisitesProps> = (props) => {
    const {
        workOrderId,
        isDisabled,
        withButton = true,
        isOpenOuter,
        setIsOpenOuter,
        refBtn,
        activeItemVersion,
    } = props;
    const [isOpen, setIsOpen] = useState(false);
    const variables = useMemo(() => ({ workOrderId }), [workOrderId]);

    const [workOrderResponse, workOrderState] = useRequest({
        requestId: 'workOrder',
        query: gqlWorkOrderVersion,
        variables,
        withEffect: isOpenOuter || isOpen,
    });

    const data = workOrderResponse?.uerWorkOrderVersion?.data;

    const defaultValues = useMemo(() => data && parseWorkOrder(data), [data]);

    const handleOnButtonClick = useCallback(() => {
        setIsOpen(true);
    }, []);

    const handleOnEditCancel = useCallback(() => {
        if (setIsOpenOuter) {
            setIsOpenOuter(false);
        } else {
            setIsOpen(false);
        }
    }, [setIsOpenOuter]);

    return (
        <>
            {withButton && (
                <Button
                    disabled={isDisabled}
                    className={cnMixSpace({ mR: 'xs' })}
                    label={`${activeItemVersion ? 'Просмотреть' : 'Редактировать'} данные`}
                    view="secondary"
                    size="s"
                    onClick={handleOnButtonClick}
                    loading={workOrderState === RequestStatus.FETCHING}
                    ref={refBtn}
                />
            )}
            {(isOpenOuter || isOpen) && workOrderState === RequestStatus.SUCCESS && (
                <WorkOrderVersionRequisitesUpdate
                    defaultValues={defaultValues as IWorkOrderData}
                    onCancel={handleOnEditCancel}
                />
            )}
        </>
    );
};

WorkOrderVersionRequisites.displayName = 'WorkOrderVersionRequisites';
